module.exports = __webpack_public_path__ + "img/52114116_L.039999f4.png";